export default {
    state: {
        modules: [
            {
                name: "Modul 1",
                assignments: [
                    {
                        id: 1,
                        taskNumber: 1,
                        summary: "Lage en funksjon som sjekker om en dato er gyldig med javascript",
                        text: `
**Denne oppgaven er fra forrige versjon av kurset - og skal løses uten bruk av model-view-controller - dvs. du skal kun levere en funksjon og unit testing av denne.** 

Når modul 1 er over, må man ha fått godkjent obligatorisk oppgave 1 og 2 for å kunne fortsette på modul 2. 

### Oppgave

Du skal lage en funksjon \`\`\`isDateValid()\`\`\` som tar en dato som parameter. Datoen vil være en tekst formatert på denne måten: 17.01.2020. Funksjonen skal returnere \`\`\`true\`\`\` hvis parameterverdien er en gyldig dato - og \`\`\`false\`\`\` ellers. Du skal *ikke* bruke \`\`\`Date\`\`\`, som er innebygget i Javascript.

En gyldig dato har disse egenskapene - og dette er det funksjonen skal sjekke *(lag en egen funksjon for hvert punkt under - og kall den fra hovedfunksjonen):*

1. Teksten må ha lengde 10.
2. Det må være punktum i tredje posisjon og i sjette posisjon.
3. År er 0000 eller større. Kan sjekkes med \`\`\`year.length === 4 && year >= '0000' && year <= '9999' \`\`\`
4. Måned er fra og med 01 til og med 12. Kan sjekkes som over.
5. Dag er fra og med 01 til og med 28 men i tillegg:
    1. 29 er lov for februar hvis det er skuddår. Bruk denne funksjonen til å finne ut om det er skuddår eller ikke:
    \`\`\` function isLeapYear(year)
        {
                return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
        }
        \`\`\`

    2. 30 er lov for alle måneder utenom februar
    3. 31 er lovlig for januar, mars, mai, juli, august, oktober og desember
Det skal skrives 11 unit tester:

* En unit test som viser at funksjonen returnerer true for en gyldig dato. Koden for denne testen kan være som under - men med ditt navn på funksjonen:\`\`\`
        const isValid = isDateValid('03.02.2020');
        assert.equal(isValid, true);
    \`\`\`

* En unit test per ting som kan være ugyldig i henhold til listen over. Unit testen skal sjekke at tingene under kommer ut som ugyldige datoer:
    * lengden er ikke 10
    * det er ikke punktum i begge de rette posisjonene
    * året består ikke av fire siffer
    * måned består ikke av to siffer 
    * måned utenfor 1-12
    * dag er større enn 31
    * dag er 31 for en måned som ikke har 31 dager
    * dag er 30 og måned er februar
    * dag er 29 og måned er februar og det ikke er skuddår

* En test som viser at 29. februar blir gyldig når det er skuddår`,
                    },
                    {
                        id: 2,
                        taskNumber: 2,
                        summary: "Fullfør stolpediagram applikasjonen etter Model View Controller-patternet",
                        text: `
Når modul 1 er over, må man ha fått godkjent obligatorisk oppgave 1 og 2 for å kunne fortsette på modul 2. 

### Oppgave

Oppgaven tar utgangspunkt i koden som er vist nederst på siden. Dette er kode som lager et stolpediagram basert på en liste av tall - hvor hvert tall er mellom 1 og 10. Oppgaven består i å fullføre applikasjonen. Den er skrevet etter Model View Controller-patternet - og koden du legger til skal også være det. 

* Gjør det mulig å velge en stolpe. Man skal kunne velge en stolpe ved å klikke på den. Den skal da få en svart ramme rundt seg, og i tillegg skal teksten oppdateres til for eksempel "Valgt stolpe: 1". Hvis man klikker på den stolpen som allerede er valgt, skal deretter ingen stolpe være valgt.
* Knappene "Endre valgt stolpe" og "Fjerne valgt stolpe" skal være disablet når ingen stolpe er valgt - og enablet ellers. 
* Når man trykker på "Fjerne valgt stolpe", skal den valgte stolpen fjernes. Alle stolper som var til høyre for denne, flyttes da ett hakk til venstre. Det vil si at om numbers er [1, 2, 3, 4, 5] - og så fjerner stolpen i midten, så skal numbers etter det være  [1, 2, 4, 5].
* Når man trykker på "Endre valgt stolpe", skal den valgte stolpen endre verdien som brukeren har skrevet i input-boksen. Det er kun 1,2,3,4,5,6,7,8, 9 og 10 som er gyldige verdier. Dersom brukeren ikke har skrevet en gyldig verdi i input-boksen, skal det gis en feilmelding. 
* Når man trykker på "Legg til stolpe", skal det legges til et nytt tall sist i listen (og en ny stolpe lengst til høyre i stolpediagrammet) med verdien som brukeren har skrevet i input-boksen. Dersom brukeren ikke har skrevet en gyldig verdi i input-boksen, skal det gis en feilmelding. 
* **Lag enhetstester av controller-funksjonene!** Altså funksjonene for å:
    * velge stolpe (teste både velge den som er valgt og en annen)
    * slette en stolpe
    * endre en stolpe
    * legge til en stolpe

\`\`\`
<div id="content">
</div>

<script>
    // hjelpevariable for både view og controller
    var contentDiv = document.getElementById('content');

    // model
    let numbers = [7, 3, 1, 5, 8];
    let chosenBar; // Variabel for hvilken stolpe som er valgt
    let inputValue; // Variabel for hva som er skrevet i input-feltet
    // view
    show();
    function show() {
        let svgInnerHtml = '';
        for (let i = 0; i < numbers.length; i++) {
            svgInnerHtml += createBar(numbers[i], i + 1);
        }
        contentDiv.innerHTML = 
            <svg id="chart" width="500" viewBox="0 0 80 60">
                '$'{svgInnerHtml}
            </svg><br/>
            Valgt stolpe: <i>ingen</i>
            <br />
            Verdi:
            <input type="number" min="1" max="10" oninput="inputValue = this.value" />
            <button>Legg til stolpe</button>
            <button disabled>Endre valgt stolpe</button><br />
            <button disabled>Fjerne valgt stolpe</button>
            ;
    }

    function createBar(number, barNo) {
        const width = 8;
        const spacing = 2;
        let x = (barNo - 1) * (width + spacing);
        let height = number * 10;
        let y = 60 - height;
        let color = calcColor(1, 10, barNo);
        return <rect width="'$'{width}" height="'$'{height}"
                            x="'$'{x}" y="'$'{y}" fill="'$'{color}"></rect>;
    }

    function calcColor(min, max, val) {
        var minHue = 240, maxHue = 0;
        var curPercent = (val - min) / (max - min);
        var colString = "hsl(" + ((curPercent * (maxHue - minHue)) + minHue) + ",100%,50%)";
        return colString;
    }

    // controller (ingenting her ennå)
</script>
\`\`\`
                        `,
                    }
                ]
            },
            // {
            //     name: "Modul 1",
            //     assignments: [
            //         {
            //             id: 1,
            //             summary: "Kort oppsummering av oppgaven.",
            //             text: "Hele oppgaveteksten, i markdown-format.222",
            //         }
            //     ]
            // },
            {
                name: "Modul 3",
                assignments: [
                    {
                        id: 3,
                        taskNumber: 1,
                        summary: "Lag et enkelt slektstre-program i C# med bruk av objektorientert programmering",
                        text: `
Alle de obligatoriske oppgavene i kurset må være innlevert og godkjent for å kunne gå videre til neste modul og for å kunne få praksis i bedrift. 

## Oppgave

Du skal lage et enkelt slektstre-program. Det skal være en konsollapplikasjon, og programmet skal kunne gjøre disse kommandoene: 

* hjelp => viser en hjelpetekst som forklarer alle kommandoene
* liste => lister alle personer med id, fornavn, fødselsår, dødsår og navn og id på mor og far om det finnes registrert. 
* vis <id> => viser en bestemt person med mor, far og barn (og id for disse, slik at man lett kan vise en av dem)

Videre i denne teksten beskrives hva du skal gjøre skritt for skritt, og du får ferdige unit tester til å sjekke at du har gjort det riktig. 

1. Lag klassen \`\`\`Person.\`\`\` En person skal ha fornavn, etternavn, fødselsår og dødsår. Alle feltene er frivillige. For eksempel skal du kunne legge inn en person selv om du ikke vet fødselsår.

   Klassen skal ha en metode \`\`\`GetDescription().\`\`\` Testen under viser hva den metoden skal returnere om alle feltene er fylt ut. Lag et unit test prosjekt og legg til en klasse PersonTest, hvor du legger testene fra oppgaveteksten, men bare testene som tester klassen Person. 

            public void TestAllFields()
            {
                var p = new Person
                {
                    Id = 17,
                    FirstName = "Ola",
                    LastName = "Nordmann",
                    BirthYear = 2000,
                    DeathYear = 3000,
                    Father = new Person() { Id = 23, FirstName = "Per" },
                    Mother = new Person() { Id = 29, FirstName = "Lise" },
                };

                    var actualDescription = p.GetDescription();
                    var expectedDescription = "Ola Nordmann (Id=17) Født: 2000 Død: 3000 Far: Per (Id=23) Mor: Lise (Id=29)";

                    Assert.AreEqual(expectedDescription, actualDescription);
                }

2. Hvis ingen av feltene er fylt ut, skal den samme metoden returnere dette:

            public void TestNoFields()
            {
                var p = new Person
                {
                    Id = 1,
                };

                    var actualDescription = p.GetDescription();
                    var expectedDescription = "(Id=1)";

                    Assert.AreEqual(expectedDescription, actualDescription);
                }
3. Lag selv en test til hvor noen felt (i tillegg til Id) er satt men ikke alle. 

4. Lag så klassen \`\`\`FamilyApp.\`\`\` Når du er ferdig med denne klassen, skal du kunne legge koden under inn i \`\`\`Program\`\`\` - og applikasjonen skal være ferdig:
    
            class Program
            {
                static void Main(string[] args)
                {
                    var sverreMagnus = new Person { Id = 1, FirstName = "Sverre Magnus", BirthYear = 2005 };
                    var ingridAlexandra = new Person { Id = 2, FirstName = "Ingrid Alexandra", BirthYear = 2004 };
                    var haakon = new Person { Id = 3, FirstName = "Haakon Magnus", BirthYear = 1973 };
                    var metteMarit = new Person { Id = 4, FirstName = "Mette-Marit", BirthYear = 1973 };
                    var marius = new Person { Id = 5, FirstName = "Marius", LastName = "Borg Høiby", BirthYear = 1997 };
                    var harald = new Person { Id = 6, FirstName = "Harald", BirthYear = 1937 };
                    var sonja = new Person { Id = 7, FirstName = "Sonja", BirthYear = 1937 };
                    var olav = new Person { Id = 8, FirstName = "Olav", BirthYear = 1903 };

                        sverreMagnus.Father = haakon;
                        sverreMagnus.Mother = metteMarit;
                        ingridAlexandra.Father = haakon;
                        ingridAlexandra.Mother = metteMarit;
                        marius.Mother = metteMarit;
                        haakon.Father = harald;
                        haakon.Mother = sonja;
                        harald.Father = olav;

                        var app = new FamilyApp(sverreMagnus, ingridAlexandra, haakon,
                            metteMarit, marius, harald, sonja, olav);
                        Console.WriteLine(app.WelcomeMessage);
                        while (true)
                        {
                            Console.Write(app.CommandPrompt);
                            var command = Console.ReadLine();
                            var response = app.HandleCommand(command);
                            Console.WriteLine(response);
                        }
                    }
                }
5. Implementer klassen \`\`\`FamilyApp\`\`\` slik at testen under lykkes. Lag en ny testklasse FamilyAppTest og legg testen der. Gitt kommandoen \`\`\`vis 3,\`\`\` skal metoden \`\`\`HandleCommand\`\`\` finne frem personen med id=3 og printe ut resultatet av et kall på metoden \`\`\`GetDescription()\`\`\` på denne personen. I tillegg skal metoden søke gjennom listen over alle personer og sjekke om det er noen som har denne personen som far eller mor. I så fall skal disse listes ut under overskriften "Barn". 
        
            public void Test()
                {
                    var sverreMagnus = new Person { Id = 1, FirstName = "Sverre Magnus", BirthYear = 2005 };
                    var ingridAlexandra = new Person { Id = 2, FirstName = "Ingrid Alexandra", BirthYear = 2004 };
                    var haakon = new Person { Id = 3, FirstName = "Haakon Magnus", BirthYear = 1973 };
                    var harald = new Person { Id = 6, FirstName = "Harald", BirthYear = 1937 };
                    sverreMagnus.Father = haakon;
                    ingridAlexandra.Father = haakon;
                    haakon.Father = harald;

                        var app = new FamilyApp(sverreMagnus, ingridAlexandra, haakon);
                        var actualResponse = app.HandleCommand("vis 3");
                        var expectedResponse = "Haakon Magnus (Id=3) Født: 1973 Far: Harald (Id=6)\\n"
                            + "  Barn:\\n"
                            + "  Sverre Magnus (Id=1) Født: 2005\\n"
                            + "  Ingrid Alexandra (Id=2) Født: 2004\\n";
                        Assert.AreEqual(expectedResponse, actualResponse);
                    }

    For å kunne sende med ingen, én eller flere personer i constructoren, kan du gjøre slik:

                public FamilyApp(params Person[] people)
                {
                    _people = new List<Person>(people);
                }

6. Lag en test som sjekker at om en person ikke har noen barn, så listes det ikke opp noen personer som barn - og overskriften "Barn" vises heller ikke. Sørg så for at testen lykkes.
                        `,
                    },
                    {
                        id: 4,
                        taskNumber: 2,
                        summary: "Implementer arv slektsforhold mellom forskjellige klasser i C#",
                        text: `
Alle de obligatoriske oppgavene i kurset må være innlevert og godkjent for å kunne gå videre til neste modul og for å kunne få praksis i bedrift. 

Du skal jobbe med starten på et sjakkspill i kommandolinjevinduet. Vi har et sjakkbrett og to typer brikker: tårn og løper. De andre brikkene er ikke laget, og det skilles ikke på om en brikke er hvit eller svart. Vi skal jobbe med å sørge for at brikkene bare får flytte etter sjakkreglene. Tårnet kan bevege seg så langt det vil mot høyre, venstre, opp eller ned. Løperen kan bevege seg så langt den vil diagonalt, det vil si opp og til høyre, opp og til venstre, ned og til høyre eller ned og til venstre.

I virkeligheten kan ikke brikkene hoppe over andre brikker, men det ser vi bort fra her. 

I vårt eksempel kan aldri en brikke flyttes til en rute hvor det står en annen brikke. (Mens i ordentlig sjakk er det lov dersom brikken er motstanderens.)

På engelsk heter tårn rook og løper bishop. Koden du tar utgangspunkt i er på engelsk. (I koden brukes engelsk, men brukergrensesnittet er på norsk.)

Dersom du får feilen under, mangler du .NET Core 2.2. Det kan du laste ned her: [https://dotnet.microsoft.com/download](https://dotnet.microsoft.com/download)
<img width="100%" src="https://i.imgur.com/3cPAvTx.png"/>

### Oppgave

1. Last ned koden som zip-fil fra [github.com/GetAcademy/SimpleChess](github.com/GetAcademy/SimpleChess). Ved å laste ned som zip-fil får du ikke med knytningen til Git - og får mindre problemer når du skal laste opp til ditt eget Git-repository senere. 

2. Endre klassen \`\`\`Piece\`\`\` til dette:

            namespace SimpleChess
            {
                abstract class Piece
                {
                    public string Symbol { get; }

                        protected Piece(string symbol)
                        {
                            Symbol = symbol;
                        }

                        public abstract bool Move(string fromPosition, string toPosition);
                    }
                }

3. I \`\`\`Program.cs\`\`\` bytt ut disse to linjene:

        var bishop = new Piece("Bishop", "LPR");
        var rook = new Piece("Rook", "TRN");

        ... med disse to linjene:
        var bishop = new Bishop();
        var rook = new Rook();

    Implementer så klassene \`\`\`Bishop\`\`\` og \`\`\`Rook\`\`\` og sørg for at alt virker som før. Begge klassene skal arve fra \`\`\`Piece.\`\`\` Etter denne endringen skal det ikke lenger være noen \`\`\`private readonly string _type;\`\`\` i \`\`\`Piece\`\`\` eller noen av de andre klassene.

                        `,
                    },
                    {
                        id: 5,
                        taskNumber: 3,
                        summary: "Forberedelse til GREPS testen",
                        text: `
For alle studenter som vil fortsette på GET IT, med praksis i bedrift, ønsker vi at dere tar den såkalte GREPS-testen før vi presenterer dere for bedrift. 

Dette er en uavhengig (uavhengig av GET Academy) og objektiv test som måler hvor dyktig programmerer du er, basert på forskning ved Universitetet i Oslo - forskning som går på hva næringslivet etterspør i en erfaren utvikler. 

Testen er ikke i C# ennå, dessverre, men i Java. Og som IDE er den basert på IntelliJ eller Eclipse - og ikke Visual Studio som dere er vant til. 

Testen er egentlig ment for ferdig utdannede utviklere med erfaring, så det er forventet lave score for dere. Testen gir likevel nyttig tilbakemelding på styrker og svakheter, og den hjelper oss å matche akkurat deg med en bedrift som passer. Det er ingen spesielle krav til at man må score på et spesielt nivå for å komme til GET IT, men man må være villige til å ta testen og dele resultatet med oss. 

Man får et resultat mellom 1 og 9, hvor 1 er det du får om du leverer ingenting. Per august 2020 har fire studenter tatt testen, og 4,0 er det beste resultatet, men vi har ingen bestemte forventninger eller krav. Scorer du 1,1, er det helt greit - og du vil få nyttig erfaring og tilbakemelding på hvilke områder det er viktist å løfte seg på. 

Man bør ikke gå rett på testen, men gjøre noen forberedelser:

1. Hvis du ikke er sikker på at du forstår grunnleggende objektorientert programmering, bør du lage noe lite og enkelt på eget initiativ. Dette bør bruke arv, interface - og ikke minst at koden er delt opp i klasser og metoder på en fornuftig måte som viser forståelse for objektorientert programmering. Send det du har laget til Terje eller en av de andre lærerne og forsikre deg om at koden er god før du fortsetter. Er den ikke det, bør du heller jobbe mer med grunnleggende objektorientert programmering enn å gå videre til GREPS-testen. 

2. Last ned og installer [IntelliJ](https://www.jetbrains.com/idea/).
    Her er to videoer som hjelper deg igang: 

    <iframe width="560" height="315" src="https://www.youtube.com/embed/DCNtseD5QYU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  
    <iframe width="560" height="315" src="https://www.youtube.com/embed/za4VTHR3PiQ" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

    Test ut at du får til det du kan i C# også i Java
    * Lage klasser og metoder
    * Input og output tastatur/skjerm
    * Arv og interface
    * Unit tester (men du trenger ikke bruke mocking)
3. [Les om GREPS-testen her](https://hs-3982482.t.hubspotstarter-il.net/e2t/tc/VW3MMY7Q-lmpV3l4sC8T-2P-W4nNzqf4c36SBN7TcW333lGnJV1-WJV7CgF6jW13XWby6DmRhnW7gtBWY8Nwl_XW3kL77x1ZpkZgW18xQxR87bDT0W487msN8Mw56WW22rp2b7zVT5yW8m8KP470242hW5jHG_m7rK53mW5DGV4x5bG5GpN89LGL8YRF9MW22YfXC53TNtnW36nJ4z6yK8X7W6sDcHd7YpH5LW3DLzCv38GnPpW1x0zN_5f0Q_-W7kqTfX6tPmVxW1P1N5t6ZC8tCW8K3M3M95XFNSW97vT8s1zFth-W3ZrfP21Hd5YjW3py63Q5Ycw_zW11MRvt7HbJR0N7DfhByV697XW7j7_Pj3WWlT-W20mQTl31h_n-W6m3nnw1ZfMhpW70Fsmh9dGKzDW6RNtPx7j3ZFQ3m-H1)
4. Send en epost til terje@getacademy.no fra din @getacademy.no-adresse når du er klar, så får du svar med en lenke til selve testen.
                        `,
                    }
                ]
            },
        ]
    },
    getters: {},
    mutations: {},
    actions: {},
}